const config = {
  REGION: "ap-southeast-2",
  BUCKET: "pg-sit-file-gateway",
  USER_POOL_ID: "ap-southeast-2_0ZBBDukRv",
  USER_POOL_APP_CLIENT_ID: "674j34d9vr6vv0sk15gl5vnv66",
  USER_POOL_DOMAIN: "https://sit-nonprod-idp-filegateway-pg.auth.ap-southeast-2.amazoncognito.com",
  IDENTITY_POOL_ID: "ap-southeast-2:39109bc8-75ce-4fa6-806f-ccfecb37bc10",
};

export default config;
